// extracted by css-extract-rspack-plugin
export default {"tabPanel":"tabPanel-2wlqc"};